import { useId, useState } from "react";

function CollapsibleSection({
  title,
  children,
  defaultExpanded = false,
  headingLevel = 2,
  headingClassName = "centered headerRad",
  contentClassName,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const contentId = useId();
  const Heading = `h${headingLevel}`;

  return (
    <>
      <Heading className={`${headingClassName} sectionHeader`}>
        <button
          type='button'
          className='sectionToggle'
          aria-expanded={isExpanded}
          aria-controls={contentId}
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          <span>{title}</span>
          <span className='sectionToggleArrow' aria-hidden='true'>
            {isExpanded ? "▾" : "▸"}
          </span>
        </button>
      </Heading>
      <div
        id={contentId}
        className={contentClassName}
        hidden={!isExpanded}
      >
        {children}
      </div>
    </>
  );
}

export default CollapsibleSection;
